"use client";

import Link from "next/link";
import React from "react";
import Button from "../ui/Button";

type CTABannerProps = {
  title: string;
  description?: string;
  buttonText?: string;
  buttonOnClick?: () => void;
  bgColor?: string;
  textColor?: string;
  buttonVariant?: "primary" | "secondary" | "outline";
  buttonSize?: "sm" | "md" | "lg";
  centerText?: boolean;
  buttonLink?: string;
};

const CTABanner: React.FC<CTABannerProps> = ({
  title,
  description,
  buttonText,
  buttonOnClick,
  textColor = "#ffffff",
  buttonSize = "lg",
  centerText = true,
  buttonLink,
}) => {
  return (
    <section className="relative overflow-hidden bg-[#313866] py-12 md:py-16">
    
      {/* Content */}
      <div
        className={`relative custom-container flex flex-col items-center gap-6 mx-auto max-w-7xl px-4 md:px-8 ${
          centerText ? "text-center" : "text-left"
        }`}
        style={{ color: textColor }}
      >
        <div>
          <h2 className="text-xl lg:text-3xl tracking-tight leading-tight  font-regular pb-2">
            {title}
          </h2>

          {description && (
            <p className="text-sm sm:text-base lg:text-lg mx-auto max-w-3xl font-light leading-tight">
              {description}
            </p>
          )}
        </div>

        {buttonText && (
          <Link href={buttonLink || "/contact-us"}>
            <Button
              size={buttonSize}
              variant="secondary"
              {...(buttonOnClick && { onClick: buttonOnClick })}
            >
              {buttonText}
            </Button>
          </Link>
        )}
      </div>
    </section>
  );
};

export default CTABanner;
